/* eslint-disable import/no-named-as-default-member */
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Fade,
  FormControlLabel,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import { updateLoanStatusById, bulkRejectSubordinateQuotes } from "../../../../store/state/loan/loan";
import loanStatuses from "../../../../constants/loanStatuses";
import PrimaryButton from "../../../Global/Buttons/PrimaryButton";
import SecondaryButton from "../../../Global/Buttons/SecondaryButton";
import LoanStep from "../Quotes/CombineQuotes/Step";

const Spacer = styled.div`
  flex-grow: 1;
`;

const IndentedParagraph = styled.p`
  margin-left: 50px;
  color: #333;
`;

const SelectedItemsNotification = styled.div`
  && {
    font-size: 17px;
    padding-left: 20px;
    margin: 0;
  }
`;

const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom: 20px;
`;

const Error = styled.div`
  color: #ff0000;
  font-size: 17px;
  padding-left: 8px;
`;

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
`;

const StyledCheckboxWrapper = styled.div`
  margin-top: 60px;
  font-weight: bold;
`;

const ButtonBar = styled.div`
  margin-right: 4px;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const MinHeightDialogContent = styled(DialogContent)`
  && {
    min-height: 340px;
  }
`;

const styles = {
  active: {
    color: "#2196f3 !important"
  },
  completed: {
    color: "#2196f3 !important"
  },
  label: {
    fontWeight: "bold"
  }
};

class PickAWinnerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      shouldShowError: false,
      errorMessage: "",
      selectedSeniorLoanIds: [],
      selectedMezzLoanIds: [],
      selectedSupplementalLoanIds: [],
      closeWithoutSubordinate: false
    };
  }

  close = () => {
    this.setState({
      selectedSeniorLoanIds: [],
      selectedMezzLoanIds: [],
      selectedSupplementalLoanIds: [],
      activeStep: 0
    });
    this.props.onClose();
  };

  updateLoanStatusById(loanIds) {
    if (loanIds && loanIds.length > 0) {
      const loanId = loanIds[0];
      this.props.updateLoanStatusById({
        loanId,
        loanStatusId: loanStatuses.WINNING_QUOTE,
        callback: () => {
          return this.props.refreshGridCallback();
        }
      });
    }
  }

  confirmClose = () => {
    const { selectedSeniorLoanIds, selectedMezzLoanIds, selectedSupplementalLoanIds } = this.state;
    this.updateLoanStatusById(selectedSeniorLoanIds);
    if (selectedMezzLoanIds.length === 0) {
      this.props.bulkRejectSubordinateQuotes({
        substituteWinnerId: selectedSeniorLoanIds[0],
        dealId: this.props.dealId,
        callback: () => {
          return this.props.refreshGridCallback();
        }
      });
    } else {
      this.updateLoanStatusById(selectedMezzLoanIds);
    }
    this.updateLoanStatusById(selectedSupplementalLoanIds);
    this.props.onClose();
    this.setState({
      activeStep: 0
    });
  };

  prevStep = () => {
    this.setState(previousState => ({
      activeStep: previousState.activeStep - 1,
      shouldShowError: false
    }));
  };

  nextStep = () => {
    this.setState(previousState => ({
      activeStep: previousState.activeStep + 1,
      shouldShowError: false
    }));
  };

  showMaxQuotesSelectedError = fieldName => {
    const fieldErrorMessage = fieldName === "selectedSeniorLoanIds" ? "You can choose only one senior quote" : "You can choose only one subordinate quote";
    this.setState({
      shouldShowError: true,
      errorMessage: fieldErrorMessage
    });
  };

  getSelectedSeniorCount = () => {
    return this.state.selectedSeniorLoanIds.length;
  };

  getSelectedMezzCount = () => {
    return this.state.selectedMezzLoanIds.length;
  };

  getSelectedSupplementalCount = () => {
    return this.state.selectedSupplementalLoanIds.length;
  };

  select = (fieldName, selectedLoanIdsCopy, id) => {
    selectedLoanIdsCopy.push(id);
    this.setState({
      shouldShowError: false,
      [fieldName]: selectedLoanIdsCopy
    });
  };

  deselect = (fieldName, selectedLoanIdsCopy, index) => {
    selectedLoanIdsCopy.splice(index, 1);
    this.setState({
      shouldShowError: false,
      [fieldName]: selectedLoanIdsCopy
    });
  };

  onToggleSenior = id => {
    this.onToggle("selectedSeniorLoanIds", id);
  };

  onToggleMezz = id => {
    this.onToggle("selectedMezzLoanIds", id);
  };

  onToggleSupplemental = id => {
    this.onToggle("selectedSupplementalLoanIds", id);
  };

  onToggle = (fieldName, id) => {
    const selectedLoanIds = this.state[fieldName];
    const selectedLoanIdsCopy = [...selectedLoanIds];
    const index = _.findIndex(selectedLoanIds, x => x === id);

    // if the checkbox is checked, do not allow a subordinate loan to be selected
    if (this.state.closeWithoutSubordinate) {
      return;
    }

    if (index === -1 && selectedLoanIdsCopy.length > 0) {
      this.showMaxQuotesSelectedError(fieldName);
    } else if (index === -1) {
      this.select(fieldName, selectedLoanIdsCopy, id);
    } else {
      this.deselect(fieldName, selectedLoanIdsCopy, index);
    }
  };

  handleCheck = () => {
    this.setState(previousState => ({
      closeWithoutSubordinate: !previousState.closeWithoutSubordinate
    }));
  };

  render() {
    const {
      shouldShowError,
      errorMessage,
      activeStep,
      selectedSeniorLoanIds,
      selectedMezzLoanIds,
      selectedSupplementalLoanIds,
      closeWithoutSubordinate
    } = this.state;
    const { isOpen, seniorLoans, mezzLoans, supplementalLoans, supplementalLoansOnly, classes } = this.props;
    if (!seniorLoans || !mezzLoans || !supplementalLoans) return null;
    const stepIconProps = {
      classes: {
        active: classes.active,
        completed: classes.completed
      }
    };

    const doMezzLoansExist = mezzLoans.length > 0;

    const isOnSeniorQuoteStep = !supplementalLoansOnly && activeStep === 0;
    const isOnMezzQuoteStep = doMezzLoansExist && activeStep === 1;
    const isOnSupplementalQuoteStep = supplementalLoansOnly && activeStep === 0;
    const isOnConfirmationStep =
      (!supplementalLoansOnly && doMezzLoansExist && activeStep === 2) ||
      (!supplementalLoansOnly && !doMezzLoansExist && activeStep === 1) ||
      (supplementalLoansOnly && activeStep === 1);

    return (
      <>
        <Dialog open={isOpen} onClose={this.close} fullWidth maxWidth="md">
          <Grid container direction="row" alignItems="center" justify="space-between">
            <DialogTitle>Pick A Winner</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.close}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <MinHeightDialogContent>
            <Stepper activeStep={activeStep} alternativeLabel>
              {!supplementalLoansOnly && (
                <Step key="senior">
                  <StepLabel StepIconProps={stepIconProps}>Choose Senior Quote</StepLabel>
                </Step>
              )}
              {!supplementalLoansOnly && doMezzLoansExist && (
                <Step key="mezz">
                  <StepLabel StepIconProps={stepIconProps}>Choose Subordinate Quote</StepLabel>
                </Step>
              )}
              {supplementalLoansOnly && (
                <Step key="supplemental">
                  <StepLabel StepIconProps={stepIconProps}>Choose Supplemental Quote</StepLabel>
                </Step>
              )}
              <Step key="confirm">
                <StepLabel StepIconProps={stepIconProps}>Confirm</StepLabel>
              </Step>
            </Stepper>
            {isOnSeniorQuoteStep && <Description>Select a senior quote:</Description>}
            {isOnMezzQuoteStep && <Description>Select a subordinate quote:</Description>}
            {isOnSupplementalQuoteStep && <Description>Select a supplemental quote:</Description>}
            {isOnConfirmationStep && (
              <Description>
                <p>
                  You have selected the following quotes for this deal. This information will be used when you close the deal and this action can only be
                  reverted by a LoanBoss Administrator.
                </p>
                {!supplementalLoansOnly && (
                  <>
                    <IndentedParagraph>
                      <strong>Senior Quote:</strong>{" "}
                      {this.state.selectedSeniorLoanIds[0] && seniorLoans ? _.find(seniorLoans, ["id", Number(this.state.selectedSeniorLoanIds[0])]).title : ""}
                    </IndentedParagraph>
                    {(selectedMezzLoanIds[0] || this.state.closeWithoutSubordinate) && (
                      <IndentedParagraph>
                        <strong>Subordinate Quote:</strong>{" "}
                        {this.state.selectedMezzLoanIds[0] && mezzLoans ? _.find(mezzLoans, ["id", Number(this.state.selectedMezzLoanIds[0])]).title : "None"}
                      </IndentedParagraph>
                    )}
                  </>
                )}
                {supplementalLoansOnly && (
                  <IndentedParagraph>
                    <strong>Supplemental Quote:</strong>{" "}
                    {this.state.selectedSupplementalLoanIds[0] && supplementalLoans
                      ? _.find(supplementalLoans, ["id", Number(this.state.selectedSupplementalLoanIds[0])]).title
                      : ""}
                  </IndentedParagraph>
                )}
                <p>Are you sure you want to do this?</p>
              </Description>
            )}
            {isOnSeniorQuoteStep && <LoanStep loans={seniorLoans} selectedLoanIds={selectedSeniorLoanIds} onToggle={this.onToggleSenior} />}
            {isOnMezzQuoteStep && <LoanStep loans={mezzLoans} selectedLoanIds={selectedMezzLoanIds} onToggle={this.onToggleMezz} />}
            {isOnMezzQuoteStep && (
              <StyledCheckboxWrapper>
                <FormControlLabel
                  label="I do not want to close with any subordinate quotes."
                  labelPlacement="end"
                  classes={{
                    label: classes.label
                  }}
                  control={(
                    <Checkbox
                      name="closeWithoutSubordinate"
                      disabled={this.state.selectedMezzLoanIds[0]}
                      checked={closeWithoutSubordinate}
                      onChange={this.handleCheck}
                      value={this.state.closeWithoutSubordinate.toString()}
                    />
                  )}
                />
              </StyledCheckboxWrapper>
            )}
            {isOnSupplementalQuoteStep && (
              <LoanStep loans={supplementalLoans} selectedLoanIds={selectedSupplementalLoanIds} onToggle={this.onToggleSupplemental} />
            )}
          </MinHeightDialogContent>
          <StyledDialogActions>
            {isOnSeniorQuoteStep && (
              <SelectedItemsNotification>
                {this.getSelectedSeniorCount()}/{1} Selected
              </SelectedItemsNotification>
            )}
            {isOnMezzQuoteStep && (
              <SelectedItemsNotification>
                {this.getSelectedMezzCount()}/{1} Selected
              </SelectedItemsNotification>
            )}
            {isOnSupplementalQuoteStep && (
              <SelectedItemsNotification>
                {this.getSelectedSupplementalCount()}/{1} Selected
              </SelectedItemsNotification>
            )}
            <Fade in={shouldShowError}>
              <Error>{errorMessage}</Error>
            </Fade>
            <Spacer />
            {isOnSeniorQuoteStep && (
              <ButtonBar>
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <PrimaryButton disabled={_.isEmpty(this.state.selectedSeniorLoanIds)} onClick={this.nextStep}>
                  NEXT
                </PrimaryButton>
              </ButtonBar>
            )}
            {isOnMezzQuoteStep && (
              <ButtonBar>
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <SecondaryButton onClick={this.prevStep}>BACK</SecondaryButton>
                <PrimaryButton disabled={!this.state.selectedMezzLoanIds[0] && !this.state.closeWithoutSubordinate} onClick={this.nextStep}>
                  NEXT
                </PrimaryButton>
              </ButtonBar>
            )}
            {isOnSupplementalQuoteStep && (
              <ButtonBar>
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <PrimaryButton disabled={_.isEmpty(this.state.selectedSupplementalLoanIds)} onClick={this.nextStep}>
                  NEXT
                </PrimaryButton>
              </ButtonBar>
            )}
            {isOnConfirmationStep && (
              <ButtonBar>
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <SecondaryButton onClick={this.prevStep}>BACK</SecondaryButton>
                <PrimaryButton onClick={this.confirmClose}>CONFIRM</PrimaryButton>
              </ButtonBar>
            )}
          </StyledDialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = ({ }) => ({});

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    updateLoanStatusById,
    bulkRejectSubordinateQuotes
  })
)(PickAWinnerModal);
